import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Articles() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="scroll-mt-20 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t('articles.title')}</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('articles.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/${a.slug}`}
              className="group rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors overflow-hidden cursor-pointer"
            >
              <div className="h-44 w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={t(`${a.prefix}.cardTitle`)}
                  title={`${t(`${a.prefix}.cardTitle`)} USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                  {t('nav.guides')}
                </span>
                <h3 className="mt-3 font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-700">
                  {t(`${a.prefix}.cardTitle`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{t(`${a.prefix}.cardDesc`)}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}